import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import MUIPowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

export default class CardAdminQueueFilterOrderActivityAtpAssessmentId extends CardClass {
    constructor(props) {
        super(props);

        this.state = {
            enabled: !!props.queue?.filter?.["order_activity.atp_assessment_id"]
        };
    }

    renderContent() {
        const filter = this.props.queue?.filter?.["order_activity.atp_assessment_id"];

        const handleChange = (value) => {
            if (!filter || !value) {
                return;
            }

            filter.properties.operator = value;

            this.props.onChange({
                filter: this.props.queue.filter
            });
        };

        const options = [
            {
                value: "is not null",
                label: "Complete"
            },
            {
                value: "is null",
                label: "Not Complete"
            }
        ];

        if (!this.state.enabled) {
            return (
                <EmptyState
                    line1="Not Enabled"
                    line2="Showing all ATP Assessment states"
                />
            );
        }

        return (
            <MUIAutocomplete
                options={options}
                getOptionLabel={option => option.label}
                value={options.find((option) => option.value === filter?.properties?.operator) || null}
                onChange={(e, option) => handleChange(option?.value || null)}
                renderInput={(params) => {
                    return (
                        <MUITextField
                            {...params}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            label="Condition"
                            variant="standard"
                            required={true}
                            sx={{ width: 220 }}
                        />
                    );
                }}
            />
        );
    }

    getActions() {
        const handleEnableDisable = () => {
            const filter = this.props.queue.filter || {};

            if (this.state.enabled) {
                delete filter["order_activity.atp_assessment_id"];
            }
            else {
                filter["order_activity.atp_assessment_id"] = {
                    type: "boolean",
                    properties: {
                        operator: "is not null"
                    }
                };
            }

            this.props.onChange({
                filter: filter
            });

            this.setState((prevState) => ({
                enabled: !prevState.enabled
            }));
        };

        return [
            (
                <MUIButton
                    component="label"
                    variant="outlined"
                    startIcon={<MUIPowerSettingsNewIcon />}
                    onClick={handleEnableDisable}
                >
                    {this.state.enabled ? "Disable" : "Enable"}
                </MUIButton>
            )
        ];
    }

    getTitle() {
        return "Filter: Order Activity > ATP Assessment";
    }
}
